module.exports = __webpack_public_path__ + "media/images/hero/hero1-house-background-corner-1d382104cc5be2a55f047b212026ef57.svg";